// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".cn-products-list__list{grid-template-columns:repeat(auto-fill,minmax(265px,1fr));grid-row-gap:var(--size-3xl);row-gap:var(--size-3xl);grid-column-gap:var(--size-xl);-moz-column-gap:var(--size-xl);column-gap:var(--size-xl);display:grid}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
